import InfoDrawer from './InfoDrawer'

export default InfoDrawer
